import { MetadataTypeDescriptor } from "client/resources/dynamicFormResources";

export default class MetadataTypeHelpers {
    static isCompositeType(property: MetadataTypeDescriptor) {
        const validSimpleTypes: string[] = [ "raw_list", "raw_map", "bool", "boolean", "string", "string[]", "long", "int", "bool?", "long?", "int?", "SensitiveValue" ];
        return !validSimpleTypes.includes(property.Type);
    }

    static isValidatableType(property: MetadataTypeDescriptor) {
        const validValidationTypes: string[] = [ "string", "string[]", "long", "int", "SensitiveValue" ];
        return validValidationTypes.includes(property.Type);
    }

    static getRequiredMessage(property: MetadataTypeDescriptor) {
        return property.DisplayInfo.Label + " is required";
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/DynamicForm/MetadataTypeHelpers.tsx